import { Empty } from 'antd';
import React from 'react'

const GenerateSummary = () => {
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'top',
        height: '100vh',
        margin: 0,
      }}
    >
      <Empty />
    </div>
  );
};

export default GenerateSummary;